import axios from 'axios';

const deleteProductDocument = (docId) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/product/deleteProductDocument`, { _id: docId })
    .then(res => res)
    .catch(err => err);
};

export default deleteProductDocument;
